import { Map } from 'immutable';
import { byValue, ascending, occurrence, descending } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import { requiredParamsForFilterRequest } from './ListOfFiltersConstants';

export function chunksToItemsMap(chunks) {
  if (!chunks) {
    return Map();
  }

  return chunks.reduce((res, item) => res.concat(item.get('items')), Map());
}

export function getAllGroupsFromChunks(filter) {
  return chunksToItemsMap(filter.getIn(['chunks', occurrence, ascending]))
    .concat(chunksToItemsMap(filter.getIn(['chunks', occurrence, descending])))
    .concat(chunksToItemsMap(filter.getIn(['chunks', byValue, ascending])))
    .concat(chunksToItemsMap(filter.getIn(['chunks', byValue, descending])));
}

export function getGroupsFromChunksForCurrentSorting(filter, sortingType, sorting) {
  return chunksToItemsMap(filter.getIn(['chunks', sortingType, sorting]));
}

export function areParamsForFiltersRequestValid(paramsForFiltersRequest) {
  return requiredParamsForFilterRequest.every((key) => Boolean(paramsForFiltersRequest[key]));
}
